export default __webpack_public_path__ + "static/media/twitter.0ff04aca.png";